import Table from '../../form/component/Table'
import {renderProcessName, renderTaskName,} from '../../process/util/names'
import {renderStoreName} from "../../store/util/renderStoreName";
import {renderCountryName} from "../../customer/util/names";
import {COUNTRY_CODE_LIST} from "../../internationalization/const";

export default (currentUserId) => {
    const columnList = []

    columnList.push({
        property: 'created',
        header: 'Created',
        comparator: Table.dateComparator('created'),
        renderer: Table.dateTimeRenderer('created'),
    })

    columnList.push({
        property: 'due',
        header: 'Due',
        comparator: Table.dateComparator('due'),
        renderer: Table.dateTimeRenderer('due'),
    })

    columnList.push({
        property: 'processName',
        header: 'process Name',
        renderer: processInstance => {
            return renderProcessName(processInstance.processName)
        },
        sortValue: processInstance => {
            return renderProcessName(processInstance.processName)
        },
    })

    columnList.push({
        property: 'name',
        header: 'taskname',
        renderer: processInstance => {
            return renderTaskName(processInstance.name)
        },
        sortValue: processInstance => {
            return renderTaskName(processInstance.name)
        },
    })

    columnList.push({
        property: 'processDisplayName',
        header: 'Name',
    })

    columnList.push({
        property: 'complexity',
        header: 'Complexity',
    })

    columnList.push({
        property: 'priority',
        header: 'Priority',
    })

    columnList.push({
        property: 'reference',
        header: 'Reference',
    })

    columnList.push({
        property: 'status',
        header: 'Status',
        renderer: task => {
            if (task.assignedToUserId === currentUserId) {
                return 'my task ' + task.status
            }
            if (task.assignedToUserId !== null) {
                return 'assigned ' + task.status
            }
            return task.status
        },
    })

    columnList.push({
        property: 'store',
        header: 'Store',
        renderer: processInstance => {
            return renderStoreName(processInstance.store)
        },
    })

    columnList.push({
        property: 'countryCode',
        header: 'Country',
        renderer: processInstance => {
            return renderCountryName(processInstance.countryCode)
        },
        filterType: 'select',
        filterOptions: COUNTRY_CODE_LIST.map(country => ({
            id: country.value,
            value: country.value,
        })),
    })

    columnList.push({
        property: 'attachmentAgreed',
        header: 'ATT AGREE',
    })

    columnList.push({
        property: 'attachmentNeeded',
        header: 'ATT NEED',
    })

    columnList.push({
        property: 'treatmentPlanDeadline',
        header: 'TP Deadline',
        comparator: Table.dateComparator('treatmentPlanDeadline'),
        renderer: Table.dateTimeRenderer('treatmentPlanDeadline'),
    })

    return columnList
}



// WEBPACK FOOTER //
// ./src/modules/worklist-attachment/component/worklist-attachment-column-list.js